module.exports = __webpack_public_path__ + "panel/img/male.df214c60.png";